import React from 'react';
import { Typography } from '@mui/material';

/**
 * Patient name template
 */
export const PatientTemplate: React.FC<{ name?: string }> = ({ name }) => {
  return (
    <Typography variant="body2" sx={{ fontWeight: 500 }}>
      {name || '-'}
    </Typography>
  );
};

export default PatientTemplate;
